// extracted by mini-css-extract-plugin
export default {"search__title":"Search_search__title__LEKyA"};